import { AccountType } from '@financial/shared';

/** Metadatos de presentación por tipo de cuenta. */
export const ACCOUNT_TYPE_META: Record<AccountType, { label: string; icon: string; color: string }> =
  {
    [AccountType.BANK]: { label: 'Banco', icon: '🏦', color: '#2563eb' },
    [AccountType.SAVINGS]: { label: 'Ahorros', icon: '🐷', color: '#15803d' },
    [AccountType.CETES]: { label: 'CETES', icon: '📈', color: '#7c3aed' },
    [AccountType.CAJA_AHORRO]: { label: 'Caja de ahorro', icon: '🧰', color: '#b45309' },
    [AccountType.CASH]: { label: 'Efectivo', icon: '💵', color: '#0891b2' },
  };

export const ACCOUNT_TYPE_ORDER: AccountType[] = [
  AccountType.BANK,
  AccountType.SAVINGS,
  AccountType.CETES,
  AccountType.CAJA_AHORRO,
  AccountType.CASH,
];
